/** Starting Football 101 runs (hub, first-launch offer, HOW TO PLAY "practise this", clear cards). */
import { randomSeed, SpecialsMode, type CharacterId } from '@hf/shared';
import { buildOfflineSetup, draft } from '@hf/client-core/ui-model/flow';
import { rememberChannel } from '../screens/MainMenu';
import { ui } from '@hf/client-core/ui-model/store';
import type { MatchSetup } from '@hf/client-core/ui-model/types';
import type { LessonId } from '@hf/client-core/ui-model/tutorial/catalog';
import { updateProgress } from '@hf/client-core/ui-model/tutorial/progress';

/** The opponent of a Football 101 run (and of the "play a game" offer). */
export const tutorialOpponent = (head: CharacterId): CharacterId =>
  head === 'bigtex' ? 'grandpa' : 'bigtex';

/** Start a Football 101 run at `lesson` with `head` (the match scene's lesson engine reads `ui.tutorialPlan`). */
export const startTutorial = (
  lesson: LessonId,
  head: CharacterId,
  startMatch: (s: MatchSetup) => void,
): void => {
  ui.tutorialPlan.value = { lesson };
  updateProgress({ head, offered: true });
  // back on the main menu (MAIN MENU on the graduation card, pause → quit) the focus is on FOOTBALL 101
  rememberChannel('tutorial');
  const setup = buildOfflineSetup(
    {
      ...draft.peek(),
      mode: 'tutorial',
      characters: [head, tutorialOpponent(head)],
      specials: SpecialsMode.SIGNATURE,
    },
    randomSeed(),
    ui.settings.peek().playerName,
  );
  startMatch(setup);
};
